/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const locationMemberBulkRemoveRequestSchema = z.object({
  resourceIds: z
    .array(z.int())
    .min(1)
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    }),
});
